import React, { useEffect, useState } from "react";
import { GoPlusCircle } from "react-icons/go";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { IconButton, Tooltip } from "@mui/material";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import axios from "axios";
import {
  IoCheckmarkDoneCircleSharp,
  IoDocumentTextOutline,
  IoFilterCircleOutline,
} from "react-icons/io5";

import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import { Link, useNavigate } from "react-router-dom";
import { Button, Divider, Dropdown, Modal, Skeleton, Tag } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { PiHamburger, PiHamburgerLight } from "react-icons/pi";
import { useMessage } from "../../../Components/MessageProvider/MessageProvider";
import axiosInstance from "../../../Components/axiosInstance/AxiosInstance";
import { LiaTrainSolid } from "react-icons/lia";
import { MdKeyboardDoubleArrowRight, MdOutlineCalculate } from "react-icons/md";
import moment from "moment";
import KochaHeader from "../KochaHeader";
import { IoMdInformationCircleOutline } from "react-icons/io";

export default function Vagon() {
  let navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const messageApi = useMessage();
  const elementRef = React.useRef(null);
  let [isModalOpen, setIsModalOpen] = React.useState(false);
  let [dataDetail, setDataDetail] = React.useState(null);
  let [openStatByModal, setOpenStatByModal] = React.useState(false);
  let [openFilterModal, setOpenFilterModal] = React.useState(false);
  let [filterData, setFilterData] = React.useState({
    name: "",
    INN: "",
    from_date: "",
    to_date: "",
    status: "",
    given_by: "",
  });

  const [searchText, setSearchText] = React.useState("");
  const [openClientType, setOpenClientType] = React.useState(false);

  let getVagon = async () => {
    try {
      setLoading(true);

      let { data } = await axiosInstance.get("/api/vagon");
      if (data.success) {
        console.log("data");
        console.log(data);
        setData(data.data);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  let [loadVagon, setLoadVagon] = useState(false);
  let [vagon, setVagon] = useState(false);
  let getOneVagon = async (id) => {
    try {
      setLoadVagon(true);

      let { data } = await axiosInstance.get("/api/vagon/" + id);
      if (data.success) {
        console.log("data");
        console.log(data);
        setVagon(data.data);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoadVagon(false);
    }
  };

  useEffect(() => {
    getVagon();
  }, []);

  const showModal = async (id) => {
    try {
      setLoadVagon(true);

      let { data } = await axiosInstance.get("/api/vagon/" + id);

      console.log(data);

      if (data.success) {
        // setOpenStatByModal(true);
        setDataDetail(data.data);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoadVagon(false);
    }
  };

  const items = [
    {
      key: "1",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/kocha"
        >
          <IoDocumentTextOutline className="font-[30px]" /> Yuk xatlari
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/kocha/vagonlar"
        >
          <LiaTrainSolid className="font-[30px]" /> Vagonlar
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/kocha/vagonlar/new"
        >
          <GoPlusCircle className="font-[30px]" /> Vagon
        </Link>
      ),
    },
    {
      key: "6",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/"
        >
          <MdOutlineCalculate className="font-[30px]" /> Jami
        </Link>
      ),
    },
  ];

  // loading
  if (loading) {
    return (
      <div className="pb-[50px]">
        <div className="max-w-[900px] m-auto w-[100%] flex  bg-[#fff] z-10 flex-row  items-center justify-between p-[10px]">
          <h2 className="bold text-[20px]">Yukxalari</h2>

          <div className="flex gap-1">
            <Dropdown
              menu={{
                items,
              }}
              placement="topRight"
              arrow
            >
              <Button>
                <PiHamburger />
              </Button>
            </Dropdown>
          </div>
        </div>

        <div className="w-[100%] flex flex-col items-start md:gap-2 overflow-auto">
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
        </div>
      </div>
    );
  }

  if (
    (data?.confirmed?.length == 0 && data?.unconfirmed?.length == 0) ||
    !data
  ) {
    return (
      <div>
        <div className="max-w-[900px] m-auto w-[100%] flex  bg-[#fff] z-10 flex-row  items-center justify-between p-[10px]">
          <h2 className="bold text-[20px]">Vagonlar</h2>

          <div className="flex gap-1">
            <Dropdown
              menu={{
                items,
              }}
              placement="topRight"
              arrow
            >
              <Button>
                <PiHamburgerLight />
              </Button>
            </Dropdown>
          </div>
        </div>
        <main class="grid  place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
          <div class="text-center">
            {/* <p class="text-base font-semibold text-indigo-600">404</p>
                <h1 class="mt-4 text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
                  Page not found
                </h1> */}
            <p class="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
              Vagon mavjud emas
            </p>
            <div class="mt-10 flex items-center justify-center gap-x-6">
              <Link
                to="/kocha/vagonlar/new"
                class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Vagon qo'shish
              </Link>
              <Link to="/kocha" class="text-sm font-semibold text-gray-900">
                Yukxatlari <span aria-hidden="true">&rarr;</span>
              </Link>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div>
      <KochaHeader title={"Vagonlar"} />
      <div className="pb-[70px] w-[100%]  m-auto">
        <div className="max-w-[900px] flex flex-col items-center gap-2 m-auto ">
          <Modal
            title="Mahsulot qo'shish"
            open={isModalOpen}
            loading={loadVagon}
            onOk={() => {
              setIsModalOpen(false);
            }}
            onCancel={() => {
              setIsModalOpen(false);
            }}
          >
            <p className="text-[14px] text-[#111827] p-0 m-0 col-span-2">
              {dataDetail?.written_by} yozdi
            </p>
            <p className="text-[14px] text-[#111827] p-0 m-0 col-span-2">
              {dataDetail?.id}- {dataDetail?.name}
            </p>
            <p className="text-[14px] text-[#111827] p-0 m-0 col-span-2">
              Vagon- {dataDetail?.vagon}
            </p>
            <p className="text-[14px] text-[#111827] p-0 m-0 col-span-2">
              Sana- {dataDetail?.date}
            </p>
            <p className="text-[14px] text-[#111827] p-0 m-0 col-span-2">
              izox- {dataDetail?.comment}
            </p>
          </Modal>
          {data?.unconfirmed?.map((el) => {
            console.log(el);
            return (
              // : "shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-[#10b981] hover:text-[#10b981] "
              <Link
                to={"/kocha/vagon/" + el.id}
                onContextMenu={(e) => {
                  e.preventDefault();
                  console.log(e);
                }}
                className={
                  "p-1 shrink-0 max-w-[900px] w-[100%] flex flex-col items-center justify-between gap-1 text-stone-900 text-bold cursor-pointer shadow-sm rounded-lg border-[1px] border-[#10b981] hover:text-[#10b981] "
                }
              >
                <div className="w-[100%] flex flex-row items-center justify-between">
                  <p className="text-[14px] text-[#111827] p-0 m-0 col-span-2">
                    {el.id}- {el.vagon}
                  </p>
                  <h2 className=" text-[16px] text-[#000] font-semibold m-0 p-0   ">
                    {el.name}
                  </h2>
                </div>

                <div className="w-[100%] flex flex-row items-center justify-between px-2">
                  <p
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    className="text-[14px] text-[#6b7280]  p-0 m-0"
                  >
                    {el.comment}
                  </p>
                  <p className="text-[14px] text-[#6b7280]  p-0 m-0">
                    <Tooltip
                      sx={{ fontSize: "10px" }}
                      className="text-[14px]"
                      title={`yaratildi: ${el?.created_at} \n updated: ${el?.updated_at}`}
                    >
                      {moment(el.created_at).format("DD.MM.YYYY")}
                    </Tooltip>
                  </p>
                </div>
              </Link>
            );
          })}
          <Divider orientation="left">Tasdiqlanganlar</Divider>
          {data?.confirmed?.map((el) => {
            console.log(el);
            return (
              <Link
                to={"/kocha/vagon/" + el.id}
                onContextMenu={(e) => {
                  e.preventDefault();
                  console.log(e);
                }}
                className={
                  "p-1 shrink-0 max-w-[900px] w-[100%] flex flex-col items-center justify-between gap-1 text-stone-900 text-bold  bg-[#d1fae5] cursor-pointer shadow-sm rounded-lg border-[1px] border-[#10b981] hover:text-[#10b981] "
                }
              >
                <div className="w-[100%] flex flex-row items-center justify-between">
                  <p className="text-[14px] text-[#111827] p-0 m-0 col-span-2">
                    {el.id}- {el.vagon}
                  </p>
                  <h2 className=" text-[16px] text-[#000] font-semibold m-0 p-0   ">
                    {el.name}
                  </h2>
                </div>

                <div className="w-[100%] flex flex-row items-center justify-between px-2">
                  <p
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    className="text-[14px] text-[#6b7280]  p-0 m-0"
                  >
                    {el.comment}
                  </p>
                  <p className="text-[14px] text-[#6b7280]  p-0 m-0">
                    <Tooltip
                      sx={{ fontSize: "10px" }}
                      className="text-[14px]"
                      title={`yaratildi: ${el?.created_at} \n updated: ${el?.updated_at}`}
                    >
                      {moment(el.created_at).format("DD.MM.YYYY")}
                    </Tooltip>
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
